import { formatPhoneNumber } from 'platform/form-renderer/util';
import { capitalizeFirst } from 'platform/shared/health-apps';
import { formatDateShort } from 'platform/utilities/date';
import React from 'react';

const ApplicantSummaryCard = item => {
  const {
    applicantDob,
    applicantPhone = '',
    applicantAddress: { street, city, state } = {},
    applicantRelationshipToSponsor,
  } = item ?? {};

  const address = [street, city && state ? `${city}, ${state}` : city || state]
    .filter(Boolean)
    .join(' ');

  const birthdate = applicantDob && formatDateShort(applicantDob);
  const phoneNumber = formatPhoneNumber(applicantPhone);

  return (
    <ul className="no-bullets">
      <li>
        <strong>Date of birth:</strong> {birthdate}
      </li>
      <li>
        <strong>Address:</strong> {address}
      </li>
      <li>
        <strong>Phone number:</strong> {phoneNumber}
      </li>
      <li>
        <strong>Relationship to Veteran:</strong>{' '}
        {capitalizeFirst(applicantRelationshipToSponsor)}
      </li>
    </ul>
  );
};

export default ApplicantSummaryCard;
